import Banner from "../../sections/common/banner";
import SectionServices2 from "../../sections/home/index2/section-services2";
import SectionEstimation2 from "../../sections/home/index2/section-estimation2";
import { data } from "../../../globals/data/services2";
import SectionVehicle3 from "../../sections/home/index3/section-vehicles3";

export default function Services2Page() {
    return (
        <>
            <Banner _data={data.banner} />
            <SectionServices2 _data={data.services} />
            <SectionEstimation2 _data={data.estimation} />
            <SectionVehicle3 _data={data.vehicles} />
            {/* <Banner2 _data={data.battery} />/ */}
            {/* <SectionBooking1 _data={data.booking} /> */}
            {/* <SectionPricing1 _data={data.plans} /> */}
        </>
    )
}